import React, { Fragment } from 'react';
import TradingDensityReportView from './TradingDensityReportView';

// Thin route entry — the V3 shell lives inside the view.
const TradingDensityReport = () => (
    <Fragment>
        <TradingDensityReportView />
    </Fragment>
);

export default TradingDensityReport;
